import { autoinject } from 'aurelia-framework';
import { QueryFilter } from 'lib/tables/DataFilter';
import { LoopTypeService, CheckDuplicateLoopTypeService } from 'models';
import { AuthHttpClient } from 'services/auth-http-client';
import { BaseApiService } from 'services/base-api-service';

@autoinject
export class LoopTypeServiceService extends BaseApiService<LoopTypeService> {
  constructor(httpClient: AuthHttpClient) {
    super(httpClient, LoopTypeService);
  }

  public getLoopTypeServiceList(filters: QueryFilter) {
    return this.httpClient.execWithResponseMeta<any[]>(`${LoopTypeService.ApiUrl}/list${filters.asQueryString}`, {
      method: 'GET',
    });
  }

  public async checkDuplicate(data: CheckDuplicateLoopTypeService) {
    return await this.httpClient.exec<{ IsDuplicate: boolean }>(`${LoopTypeService.ApiUrl}/checkDuplicate`, {
      method: 'POST',
      body: JSON.stringify(data),
    });
  }
}
